import uiCore = require("../core/uicore");

import { Component, Input, Output, EventEmitter } from "@angular/core";

export class WizardButtonsDirective implements uiCore.IDirective {
    
    public static ComponentDescription: uiCore.IStandardComponentDescription = {
        DirectiveId: "wizardbuttons",
        Template: require("./wizard.buttons.html"),
        AngularDependencies: [uiCore.ScopeDependency],
        Bindings: {
            onNext: "&",
            onDone: "&",
            onPrevious: "&",
            onFirstStep: "&",
            onLastStep: "&",
            onDoneText: "@",
            onDoneIcon: "@"
        }
    };
}

@Component({
    selector: "crew-wizard-buttons",
    template: require('./wizard-buttons.component.html')
})
export class WizardButtonsComponent {

    @Output()
    onNext = new EventEmitter();

    next() {
        this.onNext.emit();
    }

    @Output()
    onDone = new EventEmitter();

    done() {
        this.onDone.emit();
    }

    @Output()
    onPrevious = new EventEmitter();

    previous() {
        this.onPrevious.emit();
    }

    @Input()
    isFirstStep: boolean;
    
    @Input()
    isLastStep: boolean;

    @Input()
    isResultStep: boolean;

    @Input()
    isLoading: boolean;

    @Input()
    onDoneText: string;

    @Input()
    onDoneIcon: string;
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/components/wizard.buttons.ts